export const dateTimeToFormValue = (dateString:string) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  // Ensure two-digit padding for date/time components
  const pad = (num:number) => String(num).padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};